import { $ } from '../../../shared/js/utils/dom';
import Bus from '../../../shared/js/modules/event-bus';

const overlay = $('.overlay');
const init = () => {
  Bus.subscribe('navmain_open', 'OverlayActivate', show);
  Bus.subscribe('navmain_close', 'OverlayDeactivate', hide);
};
const show = () => {
  overlay.classList.add('overlay--is-active');
  Bus.broadcast('overlay_show', null);
};
const hide = () => {
  overlay.classList.remove('overlay--is-active');
  Bus.broadcast('overlay_hide', null);
};

init();
